module.exports = __webpack_public_path__ + "img/logo-komdigi.d34123ca.png";